import { render } from "./ReceiversContainer.vue?vue&type=template&id=285b49ca"
import script from "./ReceiversContainer.vue?vue&type=script&lang=js"
export * from "./ReceiversContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__